import { AnyFormat } from '../types';
import { Label } from '@/new/components/shadcn/label';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/new/components/shadcn/select';

interface Props {
  value: AnyFormat;
  onChange: (value: AnyFormat) => void;
  options: readonly AnyFormat[];
}

export const FormatField = ({ value, onChange, options }: Props) => (
  <div className="flex flex-col gap-2">
    <Label className="text-sm font-medium text-gray-700">Format</Label>
    <Select value={value} onValueChange={(v) => onChange(v as AnyFormat)}>
      <SelectTrigger>
        <SelectValue placeholder="Select format" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {options.map((option) => (
            <SelectItem key={option} value={option}>
              {option.toUpperCase()}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  </div>
);
